import { render, staticRenderFns } from "./OrganisationFields.vue?vue&type=template&id=0b6c8a16&"
import script from "./OrganisationFields.vue?vue&type=script&lang=js&"
export * from "./OrganisationFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports